import { styled } from "@mui/system";

export const Main = styled("main")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: theme.spacing(22),
}));

export const TopSection = styled("main")(({ theme }) => ({
  maxWidth: "569px",
  width: "100%",
  margin: "auto",
  zIndex: 0,
  height: "100%",
}));
